var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box_hd"},[_c('div',{staticClass:"box_hd_top"},[_c('span',{staticClass:"box_hd_top_title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('button',{staticClass:"box_hd_top_btn",on:{"click":_vm.quitEdit}},[_vm._v("退出")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ccd7cfa","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/homework/scheckchattop.vue
// module id = 95qx
// module chunks = 1